import classNames from "classnames";
import React, { PropsWithChildren, RefObject, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Draggable from "react-draggable";
import Button from "../button";

import { v4 as uuidv4 } from "uuid";

export type PopupProps = PropsWithChildren<{
  fullscreen?: boolean;
  noHeader?: boolean;
  onClose: () => void;
  fixSize?: string;

  closeOnOutsideClick?: boolean;
  refOpener?: RefObject<HTMLElement>;
  title?: string;
  coloredTitle?: boolean;
  portal?: boolean;
  allowClose?: boolean;
}>;

const Popup: React.FC<PopupProps> = ({
  fullscreen = false,
  noHeader = false,
  allowClose = true,
  onClose,
  //onClickOutside,
  //closeOnOutsideClick = true,
  //refOpener,
  children,
  title = "",
  fixSize,
  coloredTitle = false,
  portal,
}) => {
  const [guid] = useState(uuidv4()); //NOSONAR
  const containerRef = useRef<HTMLDivElement>(null);

  const elementRef = useRef<HTMLDivElement>(null);

  let innerContent = (
    <div ref={elementRef} className={"handle_" + guid}>
      {!noHeader && (
        <group
          {...(coloredTitle
            ? { "data-background": "main", "data-color": "white" }
            : { "data-background": "main-background" })}
          data-space="5"
        >
          <group data-wrap="no" data-align="center" data-height="30">
            <text
              data-weight="700"
              data-space="10"
              data-ellipsis=""
              data-name="popup_title"
            >
              {title}
            </text>
            {allowClose && (
              <Button
                mini
                material
                //{...(fullscreen ? null : { position: "right" })}
                className="close"
                //icon={fullscreen ? "chevron_left" : "close"}

                position={"right"}
                onClick={onClose}
              >
                <icon>close</icon>
              </Button>
            )}
          </group>
        </group>
      )}
      <div>
        <div
          id="windowContent"
          className="window_cont"
          fixed={fixSize} //NOSONAR
        >
          {children}
        </div>
      </div>
    </div>
  );
  if (!fullscreen) {
    innerContent = (
      <Draggable
        nodeRef={elementRef}
        cancel=".window_cont,.close"
        bounds="parent"
        handle={".handle_" + guid}
      >
        {innerContent}
      </Draggable>
    );
  }

  const content = (
    <div
      ref={containerRef}
      className={classNames("popup", "open", { fullscreen })}
    >
      {innerContent}
    </div>
  );

  if (!portal) {
    return content;
  }

  return createPortal(
    content,
    document.getElementById("popup-root") as HTMLElement,
  );
};

export default Popup;
